export default __webpack_public_path__ + "static/media/640_business04-nl-web.fb96bcbd.png";